var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeader = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 17.5h-5v-7A.5.5 0 0 1 8 10h4a.5.5 0 0 1 .5.5v7ZM17 17.5h-4.5v-2.417a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V17a.5.5 0 0 1-.5.5ZM7.5 17.5v-4.083a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5V17a.5.5 0 0 0 .5.5h4.5ZM9.004 4.261l.758-1.606a.26.26 0 0 1 .475 0l.758 1.606 1.694.26c.218.032.304.312.147.473l-1.226 1.25.29 1.764c.037.227-.19.4-.385.293L10 7.467 8.485 8.3c-.195.107-.422-.066-.385-.293l.29-1.765-1.227-1.25c-.157-.16-.07-.44.147-.473l1.694-.259Z"
}))));
export default SvgLeader;